/**
 * MyWeddingWiz - Auth Service
 * Pure API calls — no side effects. AuthContext handles token storage.
 */

import api from './api';

const authService = {
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data; // { success, data: { user, accessToken, refreshToken } }
  },

  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data; // { success, data: { user, accessToken, refreshToken } }
  },

  logout: async () => {
    try { await api.post('/auth/logout'); } catch { /* always succeed client-side */ }
  },

  getProfile: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  updateProfile: async (data) => {
    const response = await api.put('/auth/profile', data);
    return response.data;
  },

  changePassword: async (data) => {
    const response = await api.put('/auth/change-password', data);
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token, password, email, otp) => {
    const body = {};
    if (token) { body.token = token; body.password = password; }
    else { body.email = email; body.otp = otp; body.password = password; }
    const response = await api.post('/auth/reset-password', body);
    return response.data;
  },

  resendOtp: async (email, type = 'verify') => {
    const response = await api.post('/auth/resend-otp', { email, type });
    return response.data;
  },

  verifyEmail: async (emailOrToken, otp) => {
    const body = otp ? { email: emailOrToken, otp } : { token: emailOrToken };
    const response = await api.post('/auth/verify-email', body);
    return response.data;
  },

  resendVerification: async () => {
    const response = await api.post('/auth/resend-verification');
    return response.data;
  },

  isAuthenticated: () => !!localStorage.getItem('accessToken') // sync check only
};

export default authService;
